import { useSelector } from "react-redux";
import { selectToolName } from "../slices/footer/footerSlice";
import toolVersions from "../dictionaries/AppToolVersions";

const Footer = () => {
    const toolName = useSelector(state => selectToolName(state));
    if (toolName) {
        return <footer>
            <a style={{ alignSelf: "flex-end" }} href="https://computablepublishing.com"
                target="_blank" rel="noopener noreferrer">
                <img style={{ height: "28px" }}
                    alt="Computable Publishing logo and hyperlink to site"
                    src="/png-01-wide-tinnier.png" />
            </a>
            <div className="footer-text"
                style={{ width: "100%", wordBreak: "break-word", textAlign: "left", fontSize: "14px", alignSelf: "flex-end" }}>
                <span style={{ fontSize: "12px" }}>&#169; 2021-2025 Computable Publishing LLC, Patent Pending.</span> FEvIR<sup style={{ fontSize: "xx-small" }}>®</sup> Platform {toolVersions["FEvIR® Platform"]} uses current builds of <a
                    href="https://build.fhir.org" target="_blank" rel="noopener noreferrer">
                    FHIR<sup style={{ fontSize: "xx-small" }}>®</sup>
                </a> and <a href="https://build.fhir.org/ig/HL7/ebm/" target="_blank" rel="noopener noreferrer">
                    EBMonFHIR IG</a>.
                {toolName !== "FEvIR® Platform" &&
                    <span> {toolName} {toolVersions[toolName]}. </span>
                }<span className="footerAgreementText" style={{ fontSize: "12px" }}>Use implies agreement to the <a href="/termsofuse" target="_blank" rel="noopener noreferrer">Acceptable Use Policy</a>.</span>
                <a className="footerSupportEmail" style={{ float: "right" }} href="mailto:support@computablepublishing.com">support@computablepublishing.com</a>
            </div>
            {/*<div style={{ fontSize: "12px", paddingLeft: "14px", alignSelf: "flex-end" }}><a href="mailto:support@computablepublishing.com">support@computablepublishing.com</a></div>*/}
        </footer>
    }
    return <footer>
        <div className="footer-text">&#169; 2025 Computable Publishing LLC</div>
    </footer>
}

export default Footer;